import { Injectable, effect, inject } from '@angular/core';
import { Theme } from '@navstation-portal/shared/data-model/theme';
import { WINDOW } from '@navstation-portal/shared/util/browser';
import { LocalStorageStore } from '@navstation-portal/shared/util/ngrx';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  #window = inject(WINDOW);
  #storage = inject(LocalStorageStore).forFeature('nsp-theme', Theme.Dark);

  theme = this.#storage.data;

  constructor() {
    effect(() => this.applyTheme(this.theme()));
  }

  setTheme(theme: Theme): void {
    this.#storage.set(theme);
  }

  applyTheme(theme: Theme): void {
    const htmlElement = this.#window.document.documentElement;

    const themes = Object.values(Theme);
    themes.forEach((theme) => htmlElement.classList.remove(this.getThemeClass(theme)));

    const themeClass = this.getThemeClass(theme);
    htmlElement.classList.add(themeClass);
  }

  getThemeClass = (theme: Theme) => `app-${theme}`;
}
